var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.956 30.3262C141.602 30.9301 142.117 31.6606 142.469 32.4721C142.82 33.2836 143.001 34.1588 143 35.0432V115.402C143.001 116.251 142.834 117.092 142.509 117.876C142.185 118.661 141.709 119.374 141.108 119.974C140.508 120.575 139.795 121.051 139.011 121.375C138.226 121.7 137.385 121.867 136.536 121.866H24.9626C23.6745 121.868 22.4154 121.483 21.3481 120.762",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.646 28.4053H17.8554C15.1738 28.4053 13 30.5791 13 33.2607V111.119C13 113.8 15.1738 115.974 17.8554 115.974H132.646C135.328 115.974 137.502 113.8 137.502 111.119V33.2607C137.502 30.5791 135.328 28.4053 132.646 28.4053Z",
    fill: "#E9AF34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9761 50.1943H41.4888V57.0303H87.9761V50.1943Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.124 50.1943H106.182V57.0303H118.124V50.1943Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.124 83.8325H106.182V90.6685H118.124V83.8325Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.091 67.0132H106.182V73.8492H122.091V67.0132Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.65 100.652H106.182V107.488H121.65V100.652Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1403 36.957H41.4888V41.2314H67.1403V36.957Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.091 37.0688H106.182V41.2346H122.091V37.0688Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7074 67.0498H41.4888V73.8131H79.7074V67.0498Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5906 83.8691H41.4888V90.6323H90.5906V83.8691Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2553 100.688H41.4888V107.452H85.2553V100.688Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5776 44.6309H129.562",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4888 61.6816H129.563",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5776 78.7319H129.562",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4888 95.7822H129.563",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8241 87.1802H29.5232C29.7798 87.1802 30.0258 87.2821 30.2073 87.4636C30.3887 87.645 30.4906 87.891 30.4906 88.1476V95.3048H27.8794V88.1249C27.8794 87.8744 27.9789 87.6341 28.1561 87.4569C28.3333 87.2798 28.5736 87.1802 28.8241 87.1802Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4539 95.3564H23.916V97.6955H34.4539V95.3564Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6138 97.6953H33.7563V103.47C33.7563 103.59 33.7327 103.709 33.6868 103.82C33.6409 103.931 33.5736 104.031 33.4887 104.116C33.4039 104.201 33.3032 104.268 33.1924 104.314C33.0815 104.36 32.9627 104.384 32.8428 104.384H25.464C25.3524 104.384 25.2418 104.362 25.1386 104.319C25.0355 104.276 24.9418 104.214 24.8628 104.135C24.7838 104.056 24.7212 103.962 24.6785 103.859C24.6358 103.756 24.6138 103.645 24.6138 103.533V97.6953Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.791 100.187V104.247",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6055 100.187V104.247",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5525 65.0784V68.75H30.6592V65.0784C31.8864 64.7059 32.9389 63.9049 33.6249 62.8213C34.3109 61.7378 34.5847 60.4438 34.3965 59.1752C34.2082 57.9066 33.5704 56.7479 32.5992 55.9103C31.6281 55.0727 30.3883 54.6118 29.1059 54.6118C27.8234 54.6118 26.5836 55.0727 25.6125 55.9103C24.6414 56.7479 24.0036 57.9066 23.8153 59.1752C23.627 60.4438 23.9008 61.7378 24.5868 62.8213C25.2728 63.9049 26.3253 64.7059 27.5525 65.0784Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8486 60.1035L29.1061 61.7279V66.4562",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1064 61.7279L30.2703 60.1035",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5522 66.4561H30.659",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassification);
export default __webpack_public_path__ + "static/media/classification.2742698fbb3f10e812474a5cebaaf471.svg";
export { ForwardRef as ReactComponent };